import { Link } from "react-router-dom";
import { ArrowUpRight, BrickWall, Hammer, Layers, PaintRoller, Wrench, Building2 } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { SERVICES } from "../../data/site";

const ICONS = { BrickWall, Hammer, Layers, PaintRoller, Wrench, Building2 };

export const ServiceCard = ({ s, index, tall = false }) => {
  const Icon = ICONS[s.icon];
  return (
    <Reveal delay={index * 0.06} className={tall ? "lg:col-span-2" : ""}>
      <article
        data-testid={`service-card-${s.slug}`}
        className="group relative h-full bg-card border border-steel overflow-hidden flex flex-col transition-colors duration-500 hover:border-forest-mid"
      >
        <div className={`relative overflow-hidden ${tall ? "aspect-[16/8]" : "aspect-[16/9]"}`}>
          <img
            src={s.img}
            alt={s.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-card via-card/30 to-transparent" aria-hidden="true" />
          <span className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.25em] text-cement/90">
            {String(index + 1).padStart(2, "0")}
          </span>
          <span className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-base/70 border border-steel text-forest-glow backdrop-blur-sm" aria-hidden="true">
            <Icon size={18} />
          </span>
        </div>
        <div className="p-6 flex flex-col flex-1">
          <h3 className="font-display font-bold text-lg sm:text-xl text-white uppercase tracking-tight">{s.title}</h3>
          <p className="text-cement text-sm leading-relaxed mt-3 flex-1">{s.desc}</p>
          <Link
            to={`/servizi#${s.slug}`}
            data-testid={`service-more-${s.slug}`}
            className="mt-5 inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-metal/80 transition-colors hover:text-forest-glow"
          >
            Scopri di più <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
        <span className="absolute inset-x-0 bottom-0 h-[2px] bg-forest-glow scale-x-0 origin-left transition-transform duration-500 group-hover:scale-x-100" aria-hidden="true" />
      </article>
    </Reveal>
  );
};

export const ServiziGrid = () => (
  <section id="servizi" data-testid="servizi-section" className="py-20 lg:py-32 bg-graphite border-y border-steel">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-12 lg:mb-16">
        <SectionHeading
          number="02"
          overline="Cosa facciamo"
          lines={["I nostri servizi"]}
          description="Lavorazioni edili complete per privati, aziende e cantieri: dalla muratura alla finitura, un unico interlocutore per il tuo progetto."
        />
        <Reveal delay={0.2}>
          <Link to="/servizi" data-testid="servizi-all-button" className="btn-ghost shrink-0">
            Tutti i servizi <ArrowUpRight size={16} />
          </Link>
        </Reveal>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.slug} s={s} index={i} tall={i === 0} />
        ))}
      </div>
    </div>
  </section>
);
